import React from "react";

import { moment } from "../common/common";

import { getCityReviews } from "../../model/car";
import { Reviews } from "../car/carreviews";

import avatar_default from "../../static/images/avatar_default.png";

class Review extends React.Component {
	constructor() {
		super();
		this.state = {
			reviews: [],
			profiles: [],
			more: false,
		};
	}

	componentDidMount() {
		const reviews = this.props.reviews;
		const profiles = this.props.profiles;
		const more = this.props.hasMore;
		this.setState({
			reviews: this.state.reviews.concat(reviews),
			profiles: this.state.reviews.concat(profiles),
			more: more,
		});
	}

	getMoreReviews = () => {
		getCityReviews(this.props.city.city, 0, this.state.reviews.length, 0).then((resp) => {
			if (resp.data.data && resp.data.data.reviews && resp.data.data.profiles) {
				this.setState({
					err: resp.data.error,
					reviews: this.state.reviews.concat(resp.data.data.reviews),
					profiles: this.state.profiles.concat(resp.data.data.profiles),
					more: resp.data.data.more,
				});
			}
		});
	};

	render() {
		const { reviews, profiles, more } = this.state;
		return (
			<div className="review-section space sec">
				<div className="m-container">
					<h2 className="title">Những nhận xét tại {this.props.city.name}</h2>

					<div className="review-container">
						{reviews.map((review, i) => {
							var profile;
							if (profiles.length > 0) {
								for (var i = 0; i < profiles.length; ++i) {
									if (profiles[i].uid === review.uid) {
										profile = profiles[i];
										break;
									}
								}
							}
							return <Reviews key={review.id} review={review} reviewProfile={profile} />;
						})}
					</div>
					{more == true && (
						<div className="review-btn">
							<a className="btn btn-primary btn--xl" onClick={this.getMoreReviews}>
								Xem thêm
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default Review;
